import { render, staticRenderFns } from "./AstaDrawerStandalone.vue?vue&type=template&id=873d7bf6&scoped=true&"
import script from "./AstaDrawerStandalone.vue?vue&type=script&lang=js&"
export * from "./AstaDrawerStandalone.vue?vue&type=script&lang=js&"
import style0 from "./AstaDrawerStandalone.vue?vue&type=style&index=0&id=873d7bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873d7bf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('873d7bf6')) {
      api.createRecord('873d7bf6', component.options)
    } else {
      api.reload('873d7bf6', component.options)
    }
    module.hot.accept("./AstaDrawerStandalone.vue?vue&type=template&id=873d7bf6&scoped=true&", function () {
      api.rerender('873d7bf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaDrawerStandalone.vue"
export default component.exports